module.exports = __webpack_public_path__ + "static/media/loading.2c8de1d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/loading.svg
// module id = 64
// module chunks = 2